'use client';

import React, { FC, HTMLAttributes } from 'react';
import { IExperienceDictionary } from '@/dictionaries/pages/experience/types';
import NavBreadcrumb from '../NavBreadcrumb';
import { usePathname } from 'next/navigation';
import { useLocale } from '@/hooks/useLocale';
import { useTranslation } from '@/contexts/dictionaryContext';

interface IBreadcrumbProps extends HTMLAttributes<HTMLDivElement> {
  experienceTitle: string;
  categoryTitle: string;
}

export const Breadcrumb: FC<IBreadcrumbProps> = ({
  experienceTitle,
  categoryTitle,
}) => {
  const lang = useLocale();
  const { experiences: dict } = useTranslation();
  const pathname = usePathname();

  return (
    <NavBreadcrumb.Root className="text-gray-600 px-sm md:px-md desktop:px-lg">
      <NavBreadcrumb.Item path={lang === 'en' ? '/' : `/${lang}`}>
        {dict.breadcrumbHome}
      </NavBreadcrumb.Item>
      <NavBreadcrumb.Item
        path={
          lang === 'en'
            ? pathname.split('/').slice(0, 3).join('/')
            : pathname.split('/').slice(0, 4).join('/')
        }>
        {dict.breadcrumbExperiences}
      </NavBreadcrumb.Item>
      <NavBreadcrumb.Item
        path={pathname.substring(0, pathname.lastIndexOf('/'))}>
        {categoryTitle}
      </NavBreadcrumb.Item>
      <NavBreadcrumb.Item>{experienceTitle}</NavBreadcrumb.Item>
    </NavBreadcrumb.Root>
  );
};
